module.exports = __webpack_public_path__ + "static/img/creator_country_invite_text.66ad649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/creator/creator_country_invite_text.png
// module id = +yLW
// module chunks = 0